import React, { useEffect, useState } from "react"
import { Col, Form, Row } from "reactstrap"
import ReactQuill from "react-quill"

import FormSkeleton from "components/FormSkeleton/FormSkeleton"

import { GetTrailerWarrantyDetails } from "../../../api/api.service"
import { Button } from "../../../components/Button"
import FormikErrorText from "../../../components/FormikErrorText/FormikErrorText"
import { Modal } from "../../../components/Modal"
import { TextInput } from "../../../components/TextInput"
import { ConfiguratorPackagesStatus } from "../../../constants"
import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { FIELDS_NAME, TOGGLE_STATUS } from "./FormConfig.js"

const TITLES = {
   MODAL_ADD_TITLE: "Add Warranty",
   MODAL_UPDATE_TITLE: "Update Warranty",
   MODAL_DETAILS_TITLE: "Warranty Details",
   ADD_BTN_TEXT: "Save",
   UPDATE_BTN_TEXT: "Update",
   DETAILS_BTN_TEXT: "Done",
}

const handleStatusConversion = status => {
   return status == ConfiguratorPackagesStatus.Active ? true : false
}

const ManageWarranties = ({
   isDetailView = false,
   isOpen = false,
   onToggleModal = () => {},
   id = "",
   formik,
   isLoading = false,
}) => {
   const [status, setStatus] = useState(true)
   const [isFetching, setIsFetching] = useState(false)
   const [isDefault, setIsDefault] = useState(false)
   const [isPopular, setIsPopular] = useState(false)
   useEffect(() => {
      handleFetchDetails()
      return () => {
         // setIsLoading(false)
      }
   }, [id])
   const handleFetchDetails = async () => {
      if (!id) return

      try {
         setIsFetching(true)
         let res = await GetTrailerWarrantyDetails(id)
         formik.setValues({
            [FIELDS_NAME.NAME]: res?.name,
            [FIELDS_NAME.PRICE]: res?.price,
            [FIELDS_NAME.STATUS]: res?.status,
            [FIELDS_NAME.YEAR]: res?.year,
            [FIELDS_NAME.DESCRIPTION]: res?.description,
            [FIELDS_NAME.DEFAULT]: res?.isDefault,
            [FIELDS_NAME.IS_POPULAR]: res?.isPopular,
         })
         setIsDefault(res?.isDefault)
         setIsPopular(res?.isPopular)
         setStatus(handleStatusConversion(res?.status))
      } finally {
         setIsFetching(false)
      }
   }

   const handleModalClose = () => {
      setStatus(true)
      setIsPopular(false)
      formik.resetForm()
      onToggleModal()
   }
   const handleBooleanStatus = (evt, state, setState) => {
      let { name } = evt.target
      formik.setFieldValue(name, !state ? true : false)
      setState(!state)
   }
   const handleSetStatus = evt => {
      let { name } = evt.target
      let alteredStatus = !status
      setStatus(alteredStatus)
      formik.setFieldValue(
         name,
         alteredStatus
            ? ConfiguratorPackagesStatus.Active
            : ConfiguratorPackagesStatus.Inactive
      )
   }
   const handleSubmitForm = e => {
      e.preventDefault()
      return formik.handleSubmit()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container justify-content-center mb-0"
         sizeClasses="5"
         backdrop="static"
         modalTitle={id ? TITLES.MODAL_UPDATE_TITLE : TITLES.MODAL_ADD_TITLE}
      >
         {isFetching ? (
            <div>
               <FormSkeleton />
            </div>
         ) : (
            <div style={{ pointerEvents: isLoading ? "none" : "auto" }}>
               <Row>
                  <Col xs={12}>
                     <Form onSubmit={handleSubmitForm}>
                        <Row className="mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              Warranty
                           </label>
                           <div className="col-md-9">
                              <TextInput
                                 inputClass={isDetailView && "input-readonly"}
                                 placeholder="Enter name"
                                 name={FIELDS_NAME.NAME}
                                 {...formik.getFieldProps(FIELDS_NAME.NAME)}
                              />
                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.NAME}
                              />
                           </div>
                        </Row>

                        <Row className="mt-4 mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              No. of Years
                           </label>
                           <div className="col-md-9">
                              <TextInput
                                 min={0}
                                 type="number"
                                 step="0.01"
                                 inputClass={isDetailView && "input-readonly"}
                                 placeholder="Enter no. of years"
                                 name={FIELDS_NAME.YEAR}
                                 {...formik.getFieldProps(FIELDS_NAME.YEAR)}
                              />

                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.YEAR}
                              />
                           </div>
                        </Row>

                        <Row className="mt-4 mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              Price ($)
                           </label>
                           <div className="col-md-9">
                              <TextInput
                                 min={0}
                                 type="number"
                                 step="0.01"
                                 inputClass={isDetailView && "input-readonly"}
                                 placeholder="Enter price"
                                 name={FIELDS_NAME.PRICE}
                                 {...formik.getFieldProps(FIELDS_NAME.PRICE)}
                              />

                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.PRICE}
                              />
                           </div>
                        </Row>

                        <Row className="mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary ">
                              Description
                           </label>
                           <div className="col-md-9">
                              {!isDetailView && (
                                 <ReactQuill
                                    className="quill-description-write"
                                    theme="snow"
                                    placeholder="Enter item description"
                                    value={
                                       formik.values[FIELDS_NAME.DESCRIPTION]
                                    }
                                    onChange={value =>
                                       formik.setFieldValue(
                                          FIELDS_NAME.DESCRIPTION,
                                          value
                                       )
                                    }
                                 />
                              )}

                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.DESCRIPTION}
                              />
                           </div>
                        </Row>
                        <Row className="mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              Popular Warranty
                           </label>
                           <div className="col-md-9">
                              <ActiveInactiveSwitch
                                 isChecked={isPopular}
                                 isDisable={isDetailView}
                                 name={FIELDS_NAME.IS_POPULAR}
                                 onChange={evt =>
                                    handleBooleanStatus(
                                       evt,
                                       isPopular,
                                       setIsPopular
                                    )
                                 }
                                 activeText={TOGGLE_STATUS.Yes}
                                 inActiveText={TOGGLE_STATUS.No}
                              />
                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.IS_POPULAR}
                              />
                           </div>
                        </Row>

                        <Row className="mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              Status
                           </label>
                           <div className="col-md-9">
                              <ActiveInactiveSwitch
                                 isChecked={status}
                                 isDisable={isDetailView}
                                 name={FIELDS_NAME.STATUS}
                                 onChange={handleSetStatus}
                              />
                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.STATUS}
                              />
                           </div>
                        </Row>
                        <Row className="mb-3 align-items-center">
                           <label className=" col-md-3 col-form-label clr-theme-primary">
                              Default
                           </label>
                           <div className="col-md-9">
                              <ActiveInactiveSwitch
                                 isChecked={isDefault}
                                 isDisable={isDetailView}
                                 name={FIELDS_NAME.DEFAULT}
                                 onChange={evt =>
                                    handleBooleanStatus(
                                       evt,
                                       isDefault,
                                       setIsDefault
                                    )
                                 }
                                 activeText={TOGGLE_STATUS.Yes}
                                 inActiveText={TOGGLE_STATUS.No}
                              />
                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.DEFAULT}
                              />
                           </div>
                        </Row>

                        <div className="d-flex justify-content-center mt-3 mt-2">
                           <Button
                              isLoading={isLoading}
                              type={"submit"}
                              title={
                                 id
                                    ? TITLES.UPDATE_BTN_TEXT
                                    : TITLES.ADD_BTN_TEXT
                              }
                              className="header-button"
                              onClick={isDetailView && handleModalClose}
                           />
                        </div>
                     </Form>
                  </Col>
               </Row>
            </div>
         )}
      </Modal>
   )
}

export default ManageWarranties
